import React from "react";
import { motion } from "motion/react";

export function Map() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative w-full h-[500px] rounded-[3rem] p-[2px] overflow-hidden group shadow-2xl"
    >
      {/* Animated Gradient Border */}
      <div className="absolute inset-0 bg-gradient-to-r from-violet-600 via-fuchsia-500 to-cyan-400 animate-gradient-x opacity-50 group-hover:opacity-100 transition-opacity duration-700" />
      
      <div className="relative w-full h-full rounded-[2.9rem] overflow-hidden bg-neutral-950">
        {/* Colorful Overlays */}
        <div className="absolute inset-0 bg-gradient-to-tr from-violet-600/10 via-transparent to-cyan-500/10 pointer-events-none z-10" />
        <div className="absolute top-0 left-0 w-full h-full bg-violet-500/5 mix-blend-color pointer-events-none z-10" />
        
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d273.20294346636047!2d20.726842491244184!3d42.21939171366831!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13539553f7377d3f%3A0x9cd20b2b66d4fb66!2sergys.dev!5e0!3m2!1sen!2s!4v1773326751425!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ergys Onuzi Location"
          className="grayscale invert contrast-125 brightness-75 opacity-80 group-hover:opacity-100 group-hover:grayscale-0 group-hover:invert-0 group-hover:brightness-100 transition-all duration-1000 ease-in-out"
        />
      </div>
      
      {/* Floating Glow Orbs */}
      <div className="absolute -top-20 -right-20 w-64 h-64 bg-violet-600/20 blur-[80px] rounded-full pointer-events-none" />
      <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-cyan-600/20 blur-[80px] rounded-full pointer-events-none" />
    </motion.div>
  );
}